var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendSelfEvalQrEtoCdte(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.374,
    height: 11.137,
    viewBox: "0 0 12.374 11.137",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-list",
    transform: "translate(-16 -24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1664",
    "data-name": "Group 1664",
    transform: "translate(16 24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_739",
    "data-name": "Path 739",
    d: "M34.475,28.95A2.475,2.475,0,1,0,32,26.475,2.475,2.475,0,0,0,34.475,28.95Zm0-1.237a1.237,1.237,0,1,0-1.237-1.237A1.237,1.237,0,0,0,34.475,27.712Z",
    transform: "translate(-30.763 -24)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_740",
    "data-name": "Path 740",
    d: "M21.568,97.237a.619.619,0,0,1,.619.619v3.712h1.237V97.856A1.856,1.856,0,0,0,21.568,96H17.856A1.856,1.856,0,0,0,16,97.856v3.712h1.237V97.856a.619.619,0,0,1,.619-.619Z",
    transform: "translate(-16 -90.432)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_741",
    "data-name": "Path 741",
    d: "M131.712,88H128v1.237h3.712Z",
    transform: "translate(-119.338 -83.05)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_742",
    "data-name": "Path 742",
    d: "M128,120h3.712v1.237H128Z",
    transform: "translate(-119.338 -112.576)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_743",
    "data-name": "Path 743",
    d: "M131.712,56H128v1.237h3.712Z",
    transform: "translate(-119.338 -53.525)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendSelfEvalQrEtoCdte);
export default __webpack_public_path__ + "static/media/Send Self Eval QRE to Cdte.12dfa21fb06946586a46651c3d329816.svg";
export { ForwardRef as ReactComponent };